import { useState } from "react";
import { format, subMonths } from "date-fns";
import { fr } from "date-fns/locale";
import { FileSpreadsheet, FileText, Download } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Field, SelectField } from "./common";
import { api } from "../context/DataContext";

const MONTHS = Array.from({ length: 12 }, (_, i) => {
  const d = subMonths(new Date(), i);
  return { id: format(d, "yyyy-MM"), label: format(d, "MMMM yyyy", { locale: fr }) };
});

export const ExportDialog = ({ open, onOpenChange }) => {
  const [mois, setMois] = useState(MONTHS[0].id);
  const base = api.defaults.baseURL;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="export-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Exporter</DialogTitle>
          <DialogDescription>Téléchargez vos données pour vos bilans et votre comptabilité.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="kc-card flex items-start gap-4 p-4">
            <div className="rounded-md bg-[#0F8A5F]/10 p-2 text-[#0F8A5F]"><FileSpreadsheet className="h-5 w-5" /></div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-[var(--kc-navy)]">Excel — Demandes & missions</p>
              <p className="mt-0.5 text-xs text-[var(--kc-muted)]">Trois onglets : toutes les demandes, toutes les missions, synthèse CA par type de besoin.</p>
              <Button asChild variant="outline" size="sm" className="mt-3">
                <a href={`${base}/export/demandes.xlsx`} download data-testid="export-xlsx-link"><Download className="mr-1 h-3.5 w-3.5" />Télécharger le fichier Excel</a>
              </Button>
            </div>
          </div>
          <div className="kc-card flex items-start gap-4 p-4">
            <div className="rounded-md bg-[#B42318]/10 p-2 text-[#B42318]"><FileText className="h-5 w-5" /></div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-[var(--kc-navy)]">PDF — Bilan mensuel</p>
              <p className="mt-0.5 text-xs text-[var(--kc-muted)]">Nouvelles demandes, missions démarrées, CA signé, pipeline et taux de signature par besoin.</p>
              <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-end">
                <Field label="Mois" className="flex-1"><SelectField testId="export-mois-select" value={mois} onChange={setMois} options={MONTHS} /></Field>
                <Button asChild className="kc-btn-primary" size="sm">
                  <a href={`${base}/export/bilan.pdf?mois=${mois}`} download data-testid="export-pdf-link"><Download className="mr-1 h-3.5 w-3.5" />Télécharger le PDF</a>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
